/* facets-range.js v14 — Hinsche Gastrowelt
   Kein savedState. State kommt immer aus Shopify-Response (active Checkboxen).
   Submit nur bei: Slider loslassen, Enter in Textfeld, Blur.
   Vor Submit: alle Checkboxen dieses Filters komplett ersetzen.
*/

var HinscheRange = (function () {
  'use strict';

  function clamp(v, mn, mx) { return Math.min(Math.max(v, mn), mx); }

  function fmt(n) {
    var r = parseFloat(n.toFixed(2));
    return r % 1 === 0 ? String(Math.round(r)) : String(r);
  }

  function updateFill(container, lo, hi, absMin, absMax) {
    var fill = container.querySelector('.hinsche-range__fill');
    if (!fill) return;
    var range = absMax - absMin;
    if (range === 0) return;
    fill.style.left  = ((lo - absMin) / range * 100) + '%';
    fill.style.width = ((hi - lo)     / range * 100) + '%';
  }

  // Alle Checkboxen unchecken, dann nur Werte im Bereich [lo,hi] checken
  function syncCheckboxes(container, lo, hi, absMin, absMax) {
    var isFullRange = (lo <= absMin + 0.0001 && hi >= absMax - 0.0001);
    container.querySelectorAll('.hinsche-range__value-cb').forEach(function (cb) {
      var num = parseFloat(cb.dataset.num);
      cb.checked = !isFullRange && num >= lo - 0.0001 && num <= hi + 0.0001;
    });
  }

  function setValues(container, lo, hi) {
    var absMin = parseFloat(container.dataset.absMin);
    var absMax = parseFloat(container.dataset.absMax);
    var step   = parseFloat(container.dataset.step || '0.1');

    lo = clamp(lo, absMin, absMax);
    hi = clamp(hi, absMin, absMax);
    if (lo > hi - step) lo = Math.max(absMin, hi - step);
    if (hi < lo + step) hi = Math.min(absMax, lo + step);

    var sMin = container.querySelector('.hinsche-range__slider--min');
    var sMax = container.querySelector('.hinsche-range__slider--max');
    var tMin = container.querySelector('.hinsche-range__text--min');
    var tMax = container.querySelector('.hinsche-range__text--max');

    if (sMin) sMin.value = lo;
    if (sMax) sMax.value = hi;
    if (tMin) tMin.value = fmt(lo);
    if (tMax) tMax.value = fmt(hi);

    syncCheckboxes(container, lo, hi, absMin, absMax);
    updateFill(container, lo, hi, absMin, absMax);
  }

  function submitForm(container) {
    // Dawn's URL-Cache leeren damit keine alten Werte gemergt werden
    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.filterData = [];
    }

    // Sicherstellen: alle anderen .hinsche-range Container
    // haben ihre Checkboxen korrekt — kein Cross-Container-Merge
    // (Dawn serialisiert das gesamte Form auf einmal)

    var cb = container.querySelector('.hinsche-range__value-cb:checked');
    if (!cb) cb = container.querySelector('.hinsche-range__value-cb');
    if (!cb) return;

    // Debug: was wird submitted?
    var checkedCount = container.querySelectorAll('.hinsche-range__value-cb:checked').length;
    var param = container.dataset.param;
    console.log('[HinscheRange] Submit', param, '— gecheckte Werte:', checkedCount);

    cb.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function initRange(container) {
    if (container._ac) container._ac.abort();
    container._ac = new AbortController();
    var sig = { signal: container._ac.signal };

    var absMin = parseFloat(container.dataset.absMin);
    var absMax = parseFloat(container.dataset.absMax);
    var step   = parseFloat(container.dataset.step || '0.1');

    var sMin = container.querySelector('.hinsche-range__slider--min');
    var sMax = container.querySelector('.hinsche-range__slider--max');
    var tMin = container.querySelector('.hinsche-range__text--min');
    var tMax = container.querySelector('.hinsche-range__text--max');
    if (!sMin || !sMax || !tMin || !tMax) return;

    // State aus aktiven Checkboxen lesen (Shopify setzt checked korrekt)
    var checked = [];
    container.querySelectorAll('.hinsche-range__value-cb:checked').forEach(function(cb) {
      checked.push(parseFloat(cb.dataset.num));
    });
    var curMin = checked.length > 0 ? Math.min.apply(null, checked) : absMin;
    var curMax = checked.length > 0 ? Math.max.apply(null, checked) : absMax;
    setValues(container, curMin, curMax);

    // ── Slider: nur visuell, kein Submit beim Bewegen ──
    sMin.addEventListener('input', function () {
      var lo = parseFloat(sMin.value), hi = parseFloat(sMax.value);
      if (lo >= hi - step) { lo = hi - step; sMin.value = lo; }
      tMin.value = fmt(lo);
      updateFill(container, lo, hi, absMin, absMax);
      syncCheckboxes(container, lo, hi, absMin, absMax);
    }, sig);

    sMax.addEventListener('input', function () {
      var lo = parseFloat(sMin.value), hi = parseFloat(sMax.value);
      if (hi <= lo + step) { hi = lo + step; sMax.value = hi; }
      tMax.value = fmt(hi);
      updateFill(container, lo, hi, absMin, absMax);
      syncCheckboxes(container, lo, hi, absMin, absMax);
    }, sig);

    // Slider losgelassen → Submit
    sMin.addEventListener('change', function () { submitForm(container); }, sig);
    sMax.addEventListener('change', function () { submitForm(container); }, sig);

    // ── Textfelder: Enter oder Blur ──
    tMin.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var lo = parseFloat(tMin.value), hi = parseFloat(sMax.value);
      if (isNaN(lo)) return;
      lo = clamp(lo, absMin, hi - step);
      sMin.value = lo; tMin.value = fmt(lo);
      updateFill(container, lo, hi, absMin, absMax);
      syncCheckboxes(container, lo, hi, absMin, absMax);
      submitForm(container);
    }, sig);

    tMax.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var lo = parseFloat(sMin.value), hi = parseFloat(tMax.value);
      if (isNaN(hi)) return;
      hi = clamp(hi, lo + step, absMax);
      sMax.value = hi; tMax.value = fmt(hi);
      updateFill(container, lo, hi, absMin, absMax);
      syncCheckboxes(container, lo, hi, absMin, absMax);
      submitForm(container);
    }, sig);

    tMin.addEventListener('blur', function () {
      var lo = parseFloat(tMin.value), hi = parseFloat(sMax.value);
      if (isNaN(lo)) { setValues(container, absMin, hi); return; }
      lo = clamp(lo, absMin, hi - step);
      sMin.value = lo; tMin.value = fmt(lo);
      updateFill(container, lo, hi, absMin, absMax);
      syncCheckboxes(container, lo, hi, absMin, absMax);
      submitForm(container);
    }, sig);

    tMax.addEventListener('blur', function () {
      var lo = parseFloat(sMin.value), hi = parseFloat(tMax.value);
      if (isNaN(hi)) { setValues(container, lo, absMax); return; }
      hi = clamp(hi, lo + step, absMax);
      sMax.value = hi; tMax.value = fmt(hi);
      updateFill(container, lo, hi, absMin, absMax);
      syncCheckboxes(container, lo, hi, absMin, absMax);
      submitForm(container);
    }, sig);
  }

  function initAll() {
    document.querySelectorAll('.hinsche-range').forEach(initRange);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  var obs = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (!n || n.nodeType !== 1) return;
        if (n.classList && n.classList.contains('hinsche-range')) initRange(n);
        if (n.querySelectorAll) n.querySelectorAll('.hinsche-range').forEach(initRange);
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    obs.observe(document.body, { childList: true, subtree: true });

    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (typeof FacetFiltersForm !== 'undefined') {
        clearInterval(interval);
        var orig = FacetFiltersForm.renderFilters;
        FacetFiltersForm.renderFilters = function(html, event) {
          orig.call(this, html, event);
          setTimeout(initAll, 50);
        };
      }
      if (attempts > 50) clearInterval(interval);
    }, 100);
  });

  return { initAll: initAll };
})();

/* ── Brand-Label active-Klasse ──────────────────────────────────────────── */
document.addEventListener('change', function (e) {
  var cb = e.target;
  if (!cb || cb.type !== 'checkbox') return;
  var label = cb.closest('.hinsche-brand-label');
  if (label) label.classList.toggle('active', cb.checked);
});
